import BaseUseCase from "../../base_use_case.js";

class CurrentUserUseCase extends BaseUseCase {

  execute() {
    return this.httpClient({
      ...this.requestConfig(),
      method: "get",
      url: `/api/v1/users/current_user`
    });
  }
}

const instance = new CurrentUserUseCase();
export default instance;